import React from 'react'
import Modal from 'react-modal'
import styles from './RulesModal.module.css'

const CustomModal = (coupon) => {
  return (
<Modal isOpen={coupon.isOpen} onRequestClose={coupon.onclose} className={styles.containerModal} overlayClassName={styles.overlay } ariaHideApp={false}>
{coupon.title}
        <div className={styles.modalContent}>
          <img className={styles.modalImage} src={coupon.content.imageUrl}></img>
        <span className={styles.title}>{coupon.content.description} </span>
            <span className={styles.description}>{coupon.content.detailedDescription}</span>
            <span className={styles.rules}>
            {coupon.content.rules}
            </span>
        </div>
        <div>
        <button onClick={coupon.onClose} className={styles.confirmedButton}>
             OK, ENTENDI
        </button>
        </div>
</Modal>

  )
}

export default CustomModal
